import React from 'react'
import { Box, Text } from '@deseretbook/react-ui'
import PropTypes from 'prop-types'
import { Button } from '../../../dbWebUI'
import ViewOptions from '../mediaCard/ViewFilters'

/**
 * A component that provides common media filterable options like tabs, sorting, and view options.
 *
 * @returns {function} Component
 */
const FilterOptions = ({
  title,
  tab: currentTab,
  tabs,
  toggleTab,
  toggleView,
  view,
  sortMethod,
  updateSortMethod,
  updateFilters,
  currentFilters,
}) => {
  return (
    <Box
      isFullwidth
      alignItems="center"
      justifyContent="space-between"
      style={{ flexWrap: 'wrap' }}
    >
      <Box alignItems="center">
        <Text
          style={{
            marginRight: '1rem',
            display: 'inline-block',
            fontFamily: 'Roboto serif',
            fontWeight: 600,
            fontSize: '2rem',
          }}
        >
          {title}
        </Text>
        <Box>
          {tabs.map(({ title: tabTitle, value: tabValue }) => (
            <Button
              isRounded
              disabled={currentTab === tabValue}
              style={{
                marginRight: '0.5rem',
                border: 'none',
                padding: '10.5px 1rem',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 500,
                backgroundColor: currentTab === tabValue ? '#41d6b9' : '#f0f0f0',
                opacity: 1,
              }}
              onClick={() => currentTab !== tabValue && toggleTab(tabValue)}
            >
              {tabTitle}
            </Button>
          ))}
        </Box>
      </Box>
      {view && sortMethod ? (
        <Box>
          <ViewOptions
            currentView={view}
            toggleView={toggleView}
            currentSort={sortMethod}
            updateSort={updateSortMethod}
            currentFilters={currentFilters}
            updateFilters={updateFilters}
          />
        </Box>
      ) : null}
    </Box>
  )
}

FilterOptions.defaultProps = {
  title: 'Library',
}

FilterOptions.propTypes = {
  title: PropTypes.string,
}

export default FilterOptions
